// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6886":"16608b36","7133":"fa50ceb8"}[chunkId] + ".chunk.js";
};